import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

/**
 * Use this observable when components need to be notified once a scroll action completes for example,
 * to signal that the scroll animation triggered by the click-to-scroll directive has finished.
 * This approach hides the implementation details of scroll triggers and improve testability by
 * applying the dependency inversion principle
 */
export class ScrollSpyService {
    pauseScroll$ = new BehaviorSubject<boolean>(false);

    constructor() { }
}
